import { render, staticRenderFns } from "./ExternalProjectOverview.vue?vue&type=template&id=61c57323&"
import script from "./ExternalProjectOverview.vue?vue&type=script&lang=js&"
export * from "./ExternalProjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports